"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateMeiMei = void 0;
var components_1 = require("../../components");
var utils_1 = require("../../utils");
var backspaceKeyCode = 8;
var enterKeyCode = 13;
var commaKeyCode = 44;
var CreateMeiMei = /** @class */ (function () {
    function CreateMeiMei(target) {
        this.ref = null;
        this.inputFieldRef = null;
        this.optionalProps = components_1.options.getProps();
        this.entryList = [];
        this.removeEntry = this.removeOneEntry.bind(this);
        this.addEntry = this.addOneEntry.bind(this);
        this.render(target);
    }
    CreateMeiMei.prototype.render = function (target) {
        var box = new components_1.Box();
        var inputField = new components_1.Input();
        if (box.ref && inputField.ref) {
            target.appendChild(box.ref);
            box.ref.appendChild(inputField.ref);
            this.ref = box.ref;
            this.inputFieldRef = inputField.ref;
            this.bindEvents();
        }
    };
    CreateMeiMei.prototype.addOneEntry = function (value) {
        if (!value)
            return;
        var isValidEmail = utils_1.validateEmail(value);
        var emailChip = new components_1.Chip(value, isValidEmail, this.removeEntry);
        if (emailChip.ref && this.ref && this.inputFieldRef) {
            // add new entry before input field
            this.ref.insertBefore(emailChip.ref, this.inputFieldRef);
            // add new entry to entryList
            this.entryList.push({ entry: emailChip.ref, isValidEmail: isValidEmail, text: value });
            // Scroll wrapping box to bottom when max-height is reached
            this.ref.scrollTop = this.ref.scrollHeight;
            // clear input field after adding entries
            this.inputFieldRef.value = '';
            // run optional function
            return this.optionalProps && this.optionalProps.onAddEntry && this.optionalProps.onAddEntry();
        }
    };
    CreateMeiMei.prototype.removeOneEntry = function (target) {
        if (this.ref && target) {
            // remove entry from EntryList
            var newEntryList = this.entryList.filter(function (entry) { return entry.entry !== target; });
            this.entryList = newEntryList;
            // remove target from box
            this.ref.removeChild(target);
            // run optional function
            return this.optionalProps && this.optionalProps.onRemoveEntry && this.optionalProps.onRemoveEntry();
        }
    };
    CreateMeiMei.prototype.bindEvents = function () {
        var _this = this;
        var _a = this, ref = _a.ref, inputFieldRef = _a.inputFieldRef;
        if (ref) {
            ref.addEventListener('click', function (e) { return _this.handleClick(e); });
        }
        if (inputFieldRef) {
            inputFieldRef.addEventListener('keypress', function (e) { return _this.handleKeyPress(e); });
            inputFieldRef.addEventListener('keydown', function (e) { return _this.handleKeyDown(e); });
            inputFieldRef.addEventListener('focusout', function (e) { return _this.handleFocusOut(e); });
            inputFieldRef.addEventListener('paste', function (e) { return _this.handlePaste(e); });
        }
    };
    CreateMeiMei.prototype.handleClick = function (e) {
        e.preventDefault();
        if (e.target === this.ref && this.inputFieldRef) {
            this.inputFieldRef.focus();
        }
    };
    CreateMeiMei.prototype.handleKeyPress = function (e) {
        if (e.keyCode === enterKeyCode || e.keyCode === commaKeyCode) {
            e.preventDefault();
            this.addEntry(e.target.value);
        }
    };
    CreateMeiMei.prototype.handleKeyDown = function (e) {
        if (e.keyCode === backspaceKeyCode && e.target.value === '' && this.entryList.length > 0) {
            e.preventDefault();
            var lastEntry = this.entryList[this.entryList.length - 1].entry;
            this.removeEntry(lastEntry);
        }
    };
    CreateMeiMei.prototype.handleFocusOut = function (e) {
        e.preventDefault();
        this.addEntry(e.target.value);
    };
    CreateMeiMei.prototype.handlePaste = function (e) {
        var _this = this;
        // Stop data actually being pasted into input
        e.stopPropagation();
        e.preventDefault();
        // Get pasted data via clipboard API
        var clipboardData = e.clipboardData || window.clipboardData;
        var pastedData = clipboardData.getData('Text');
        // Split pasted data in chunks on comma and space
        var chunks = pastedData.split(/[ ,]+/).filter(function (item) { return item; });
        // Add new entries
        if (chunks && chunks.length > 0) {
            chunks.forEach(function (chunk) { return _this.addEntry(chunk); });
        }
    };
    return CreateMeiMei;
}());
exports.CreateMeiMei = CreateMeiMei;
